import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
// import JobOpenings from "../JobAdminContent/JobOpenings";
// import Dashboard from "../JobAdminContent/Dashboard";
// import Shortlisting from "../JobAdminContent/Shortlisting";
// import Reports from "../JobAdminContent/Reports";
import {
  AiOutlineFolder,
  AiOutlineDashboard,
  AiOutlineFileText,
  AiOutlineUserCheck,
  AiOutlineUser,
} from "react-icons/ai";
import { MdOutlinePostAdd, MdOutlineReport } from "react-icons/md";

const JobManagementPage = () => {
  const [activeNav, setActiveNav] = useState("Job Openings");
  const [stats, setStats] = useState({
    activeJobs: 0,
    totalApplications: 0,
    shortlistedCount: 0,
  });
  const [isNavOpen, setIsNavOpen] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
  //TODO:Comment during production build
  // const apiUrl = "http://localhost:5000/";

  const handleNavClick = (nav) => {
    setActiveNav(nav);
    setIsNavOpen(false);
  };

  useEffect(() => {
    const fetchJobStats = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/job-stats`);

        if (!response.ok) throw new Error("Failed to fetch stats");

        const data = await response.json();
        setStats({
          activeJobs: data.activeJobs || 0,
          totalApplications: data.totalApplications || 0,
          shortlistedCount: data.shortlistedApplications || 0,
        });
      } catch (error) {
        console.error("Error fetching job stats:", error);
      }
    };

    fetchJobStats();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white shadow-md">
        <Header />
      </div>

      {/* Page Title */}
      <div className="sticky top-[4rem] z-40 bg-gray-100 pt-4 pb-1">
        <h1 className="text-xl lg:text-2xl font-bold text-gray-600 text-center">
          Job Application Management
        </h1>
      </div>

      {/* Main content */}
      <div className="flex-1 bg-gray-100 overflow-hidden">
        <div className="flex flex-col lg:flex-row max-w-full px-3 lg:px-10 mx-auto py-3 w-full gap-5">
          {/* Mobile Hamburger */}
          <div className="lg:hidden px-4 pt-2">
            <button
              className="text-blue-700 bg-white shadow-md p-2 rounded-md"
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isNavOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16m-7 6h7"
                  }
                />
              </svg>
            </button>
          </div>

          {/* Sidebar Navigation */}
          <nav
            className={`bg-white shadow-md p-6 rounded-md lg:block lg:w-1/6 lg:top-0 sticky top-[8rem] h-[calc(100vh-11.8rem)] overflow-y-auto ${
              isNavOpen ? "block" : "hidden"
            } lg:relative lg:flex lg:flex-col`}
          >
            <ul className="space-y-4 font-semibold">
              <NavItem
                icon={<AiOutlineDashboard size={23} />}
                label="Dashboard"
                activeNav={activeNav}
                // onClick={() => handleNavClick("Dashboard")}
              />
              <NavItem
                icon={<MdOutlinePostAdd size={23} />}
                label="Job Openings"
                activeNav={activeNav}
                // onClick={() => handleNavClick("Job Openings")}
              />

              <NavItem
                icon={<AiOutlineUser size={23} />}
                label="Shortlisting"
                activeNav={activeNav}
                // onClick={() => handleNavClick("Shortlisting")}
              />
              <NavItem
                icon={<MdOutlineReport size={23} />}
                label="Reports"
                activeNav={activeNav}
                // onClick={() => handleNavClick("Reports")}
              />
            </ul>
          </nav>

          {/* Content Area */}
          <div className="w-full lg:w-5/6 bg-white shadow-lg p-2 lg:p-6 rounded-md h-[calc(100vh-11.8rem)] overflow-x-auto lg:overflow-hidden">
            <div className="content">
              {
                activeNav === "Job Openings"
                //   && <JobOpenings />
              }
              {
                activeNav === "Dashboard"
                //   && <Dashboard stats={stats} />
              }
              {
                activeNav === "Shortlisting"
                //   && <Shortlisting />
              }
              {
                activeNav === "Reports"
                //   && <Reports />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Navigation Item Component
const NavItem = ({ icon, label, activeNav, onClick }) => {
  return (
    <li
      onClick={onClick}
      className={`cursor-pointer p-3 rounded-md text-gray-600 hover:bg-gray-300 transition duration-200 flex items-center ${
        activeNav === label ? "bg-blue-700 text-white" : ""
      }`}
    >
      <div className="flex items-center">
        {icon && (
          <span
            className={`mr-3 text-blue-700 ${
              activeNav === label ? "text-white" : ""
            }`}
          >
            {icon}
          </span>
        )}
        <span>{label}</span>
      </div>
    </li>
  );
};

export default JobManagementPage;
